/**
 * Combined util: decode + extract username
 */
export function getUsernameFromEncodedMatrixId(encoded: string): string | null {
  const decoded = decodeQuotedPrintable(encoded);
  return extractUsernameFromMatrixId(decoded);
}

/**
 * Decodes quoted-printable sequences like =40 or =3a
 */
function decodeQuotedPrintable(input: string): string {
  return input.replace(/=([0-9A-Fa-f]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
}

/**
 * Extracts the MXID username from a decoded Matrix ID
 * Example: "@alice:example.org" -> "alice"
 */
function extractUsernameFromMatrixId(matrixId: string): string | null {
  const match = matrixId.match(/^@([^:]+):/);
  return match ? match[1] : null;
}
